// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"40d7edd1","297":"0ae2bdab","643":"87f67407"}[chunkId] + ".chunk.js";
};